export const EDITOR_TYPES = {
  PHOTOBOOK: "photobook",
  CALENDER: "calendar",
  CARD: "card",
  VISITING_CARD: "visitingcard",
  WALLART: "wallart",
  GIFTCARD: "giftcard",
  PRINT: "print",
  CANVAS: "canvas",
  ACRYLIC: "acrylic",
  PHOTO_FRAME: "photoframe",
  PHOTO_MAGNET: "photomagnet",
  PHOTO_STRIP: "photostrip",
  CUSTOME_PRODUCT: "custom_product",
  GREETING_CARD: "greetingcard",
  LAYFLATALBUM: "layflatalbum",
};
export const EDITOR_SUB_TYPES = {
  CALENDER: {
    WOODEN_CALENDER: "wooden_calendar",
    MOUNTAIN_CALENDER: "mountain_calendar",
    WALL_CALENDER: "wall_calendar",
  },
  ACRYLIC: {
    WALL: "wall",
    TABLE: "table",
  },
  CUSTOME_PRODUCT: {
    WATER_BOTTLE: "water_bottle",
    T_SHIRT: "t_shirt",
    PHOTO_KEYCHAIN: "photo_keychain",
    CAP: "cap",
    WALL_CLOCK: "wall_clock",
    PENDRIVE: "pendrive",
    MOUSE_PAD: "mouse_pad",
  },
  GREETING_CARD: {
    SINGLE_SIDE: "single_side",
    DOUBLE_SIDE: "double_side",
    FOLDABLE: "foldable",
  },
  PHOTOBOOK: {
    AI_GENERATED_FOR_KIDS: "ai_generated_for_kids",
  },
  LAYFLATALBUM: {
    MAGAZINE: "magazine",
  }
};

// Which subtypes are actually valid for a given editor type.
// Needed because `canvas.settings.subtype` initialises to "wall_calendar" for EVERY
// editor type (see the canvas slice initial state), so the value alone can't be
// trusted — sending it as a filter on a photobook would match nothing. Use
// isValidSubTypeForEditor() before filtering by it. Editor types absent from this
// map have no subtypes at all.
export const EDITOR_TYPE_SUB_TYPES = {
  [EDITOR_TYPES.CALENDER]: EDITOR_SUB_TYPES.CALENDER,
  [EDITOR_TYPES.ACRYLIC]: EDITOR_SUB_TYPES.ACRYLIC,
  [EDITOR_TYPES.CUSTOME_PRODUCT]: EDITOR_SUB_TYPES.CUSTOME_PRODUCT,
  [EDITOR_TYPES.GREETING_CARD]: EDITOR_SUB_TYPES.GREETING_CARD,
  [EDITOR_TYPES.PHOTOBOOK]: EDITOR_SUB_TYPES.PHOTOBOOK,
  [EDITOR_TYPES.LAYFLATALBUM]: EDITOR_SUB_TYPES.LAYFLATALBUM,
};

export const isValidSubTypeForEditor = (editorType, subtype) =>
  Boolean(subtype) &&
  Object.values(EDITOR_TYPE_SUB_TYPES[editorType] || {}).includes(subtype);
export const EDITOR_ASSETS = {
  BACKGROUND: "background",
  LAYOUT: "layout",
  IDEA: "idea",
  FONT: "font",
  THEME: "theme",
  TEMPLATE: "template",
  MASK: "mask",
  STICKER: "clipart",
  PROJECT: "project",
  CAPTIONS: "captions",
};

export const ERROR_MESSAGES = {
  api_error_message:
    "We’re experiencing technical difficulties. Please try again later.",
  delete_confirmation: "Are you sure you want to delete this record?",
};
export const USER_TYPES = {
  ADMIN: 3,
  CUSTOMER: 6,
  SUPERUSER: 2,
  EMPLOYEE: 5,
};
export const ORIENTATION = {
  PORTRAIT: "P",
  LANDSCAPE: "L",
  SQUARE: "S",
};

export const CRYPTO_SECRET = "printpoz#123@@";
export const LOGIN_CRYPTO_KEY = "QUICKORDERDEVELOPER";

// Editor versions 
// Version 2: Uses foreignObject for text rendering (word-wrap, justify support)
// Version 1 or undefined: Uses Old SVG text rendering
export const EDITOR_VERSION = 2;
